import { Col, Row, Collapse, InputNumber, DatePicker } from 'antd'
import { useTranslation } from '~/common/hooks/useTranslation'
import { eventData, assetTypeData } from './data/tradingHistoriesDataProfile'
import { useMediaQuery } from 'react-responsive'
import { SCREEN_SIZE } from '~/common/constants'
import dayjs from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat'
dayjs.extend(customParseFormat)
export const FilterHistory = (props) => {
  const {
    event,
    assetType,
    date,
    setEvent,
    setAssetType,
    setDate,
    classCustom,
  } = props
  const { t } = useTranslation()
  const dateFormatList = ['YYYY/MM/DD']
  const clearAll = () => {
    setEvent([])
    setAssetType([])
    setDate([null, null])
  }

  const onChangeDate = (newValue) => {
    setDate(newValue)
  }
  const isMobile = useMediaQuery({ query: SCREEN_SIZE.TABLET })
  return (
    <div
      className={`${
        classCustom ?? 'filter__common'
      } bg-[#0d2758] p-[16px] max-w-[372px] w-[372px]`}
    >
      {isMobile ? (
        <></>
      ) : (
        <>
          {' '}
          <Row className="">
            <Col span={12}>
              <div className="text-[16px]"> {t('filter')}</div>
            </Col>
            <Col span={12} className="flex justify-end">
              <div
                className="text-[16px] text-[#FAAD14] cursor-pointer"
                onClick={() => {
                  clearAll()
                }}
              >
                {t('clearAll')}
              </div>
            </Col>
          </Row>
          <hr className="my-5" />
        </>
      )}

      <Collapse
        defaultActiveKey={['event', 'assetType', 'date']}
        expandIconPosition={'end'}
        items={[
          //event
          {
            key: 'event',
            label: t('common.filter.tag.event'),
            children: (
              <div className="flex flex-wrap gap-[10px]">
                {eventData?.map((data) => (
                  <div
                    key={data}
                    className={`flex items-center justify-center min-w-[32px] h-[40px] rounded-[8px] bg-[#00113F] cursor-pointer hover:bg-opacity-80 py-[4px] px-[8px] ${
                      event?.find((rank) => rank === data) && 'bg-[#1950b3]'
                    }`}
                    onClick={() => {
                      event?.find((rank) => rank === data)
                        ? setEvent(event.filter((rank) => rank !== data))
                        : setEvent((oldRank) => [...oldRank, data])
                    }}
                  >
                    <div className="text-[14px] font__M__plus font-bold">
                      {t(`common.filter.event.${data}`)}
                    </div>
                  </div>
                ))}
              </div>
            ),
          },
          //assetType
          {
            key: 'assetType',
            label: t('common.filter.tag.assetType'),
            children: (
              <div className="flex flex-wrap gap-[10px]">
                {assetTypeData?.map((data) => (
                  <div
                    key={data.addressContract}
                    className={`flex items-center justify-center min-w-[32px] p-[10px] h-[40px] rounded-[8px] bg-[#00113F] cursor-pointer hover:bg-opacity-80 py-[4px] px-[8px] ${
                      assetType?.find(
                        (rank) => rank === data.addressContract,
                      ) && 'bg-[#1950b3]'
                    }`}
                    onClick={() => {
                      if (data.name === 'enhanceItem') {
                        const enhance = data.addressContract
                        const crystal = process.env.REACT_APP_ADDRESS_CRYSTAL_ITEM
                        const both = [enhance, crystal]

                        const isSelected = both.every(addr => assetType.includes(addr))

                        if (isSelected) {
                          setAssetType(assetType.filter(addr => !both.includes(addr)))
                        } else {
                          setAssetType([...new Set([...assetType, ...both])])
                        }
                      } else {
                        assetType?.find((rank) => rank === data.addressContract)
                          ? setAssetType(
                              assetType.filter(
                                (rank) => rank !== data.addressContract,
                              ),
                            )
                          : setAssetType((oldRank) => [
                              ...oldRank,
                              data.addressContract,
                            ])
                      }
                    }}
                  >
                    <div
                      className="text-[14px] font__M__plus font-bold p-2 "
                      style={{ marginLeft: '-7px' }}
                    >
                      {t(`common.filter.assetType.${data.name}`)}
                    </div>
                  </div>
                ))}
              </div>
            ),
          },
          {
            key: 'date',
            label: t('common.filter.tag.date'),
            children: (
              <div>
                <div className="w-full font__M__plus font-medium">
                  <Row className="flex items-center justify-between">
                    <Col span={11}>
                      <DatePicker
                        inputReadOnly
                        getPopupContainer={(trigger) => trigger.parentNode}
                        style={{ border: 'none' }}
                        format={dateFormatList}
                        className="h-[44px] w-full bg-[#00113F]"
                        value={date?.[0] ? dayjs.unix(date[0]) : null}
                        onChange={(value) => {
                          if (!value) {
                            onChangeDate([null, date?.[1] ?? null])
                            return
                          }
                          const startTimestamp = value.startOf('day').unix()
                          onChangeDate([startTimestamp, date?.[1] ?? null])
                        }}
                      />
                    </Col>
                    <Col span={1} className="flex items-center justify-center">
                      -
                    </Col>
                    <Col span={11}>
                      <DatePicker
                        inputReadOnly
                        getPopupContainer={(trigger) => trigger.parentNode}
                        style={{ border: 'none' }}
                        format={dateFormatList}
                        className="h-[44px] w-full bg-[#00113F]"
                        value={date?.[1] ? dayjs.unix(date[1]) : null}
                        onChange={(value) => {
                          if (!value) {
                            onChangeDate([date?.[0] ?? null, null])
                            return
                          }
                          const endTimestamp = value.endOf('day').unix()
                          onChangeDate([date?.[0] ?? null, endTimestamp])
                        }}
                        disabledDate={(current) => {
                          if (!date?.[0]) return false
                          return (
                            current &&
                            current < dayjs.unix(date[0]).startOf('day')
                          )
                        }}
                      />
                    </Col>
                  </Row>
                </div>
              </div>
            ),
          },
        ]}
      />
    </div>
  )
}
